module.exports = __webpack_public_path__ + "static/details_label.265be9ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/_stories/_details/details_label.jpg
// module id = 911
// module chunks = 85306613037350